module.exports = __webpack_public_path__ + "img/forecast_dimensions.e6efd88f.png";